import { render, staticRenderFns } from "./geofences-edit.vue?vue&type=template&id=fa619672"
import script from "./geofences-edit.vue?vue&type=script&lang=js"
export * from "./geofences-edit.vue?vue&type=script&lang=js"
import style0 from "./geofences-edit.vue?vue&type=style&index=0&id=fa619672&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports